import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import QuickscanLogin from '../views/QuickscanLogin.vue';
import QuickscanStep1 from '../views/QuickscanStep1.vue';
import QuickscanStep2 from '../views/QuickscanStep2.vue';
import QuickscanStep3 from '../views/QuickscanStep3.vue';
import QuickscanFinish from '../views/QuickscanFinish.vue';
import QuickscanIncomplete from '../views/QuickscanIncomplete.vue';
import QuickscanRejected from '../views/QuickscanRejected.vue';
import QuickscanThanks from '../views/QuickscanThanks.vue';
import PrivacyStatement from '../views/PrivacyStatement.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: { name: 'quickscan_login' },
        components: {
            default: QuickscanLogin
        },
    },
    {
        path: '/quickscan',
        name: 'quickscan_login',
        component: QuickscanLogin,
    },
    {
        path: '/quickscan/step1',
        name: 'quickscan_step1',
        component: QuickscanStep1,
        meta: { requiresAuth: true },
    },
    {
        path: '/quickscan/step2',
        name: 'quickscan_step2',
        component: QuickscanStep2,
        meta: { requiresAuth: true },
    },
    {
        path: '/quickscan/step3',
        name: 'quickscan_step3',
        component: QuickscanStep3,
        meta: { requiresAuth: true },
    },
    {
        path: '/quickscan/finish',
        name: 'quickscan_finish',
        component: QuickscanFinish,
        meta: { requiresAuth: true },
    },
    {
        path: '/quickscan/incomplete',
        name: 'quickscan_incomplete',
        component: QuickscanIncomplete,
        meta: { requiresAuth: true },
    },
    {
        path: '/quickscan/rejected',
        name: 'quickscan_rejected',
        component: QuickscanRejected,
        meta: { requiresAuth: true },
    },
    {
        path: '/quickscan/thanks',
        name: 'quickscan_thanks',
        component: QuickscanThanks,
        meta: { requiresAuth: true },
    },
    {
        path: '/privacy-statement',
        name: 'privacy_statement',
        component: PrivacyStatement,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    let redirect = null;

    const loggedIn = store.getters.quickscanLoggedIn;
    if (to.matched.some(route => route.meta.requiresAuth) && !loggedIn) {
        console.log('Unauthorized route access, redirecting...');
        redirect = { name: 'home' };
    }

    if (redirect === null) {
        next();
    } else {
        next(redirect);
    }
});

export default router;
